import React, { useEffect, useState } from "react";
import { TableLoader, TableModel } from "../../components/tableLoader/index.js";
import { useDispatch, useSelector } from "react-redux";
import {
  currentNotificationAction,
  showElectronicConsentsDetailAction,
  showNotificationDetailAction,
} from "../../redux/actions/actions.js";
import * as cls from "../notificationsSummaries/notificationsSummaries.module.scss";
import ModalElectronicConsepts from "../../components/modalnotifications/ModalElectronicConsepts.jsx";

export { ElectronicConsents };

function ElectronicConsents({}) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [key, setKey] = useState(0);
  const { openElectronicConsents } = useSelector(
    (state) => state.notifications
  );
  const dispatch = useDispatch();

  const loader = {
    title: "Список электронных согласий",
    icon: "survey",
    request: {
      method: "post",
      path: "/student/electronic_consents",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    },
    parser: createModel,
  };
  const handleModalOpen = (data) => {
    dispatch(currentNotificationAction(data));
    dispatch(showElectronicConsentsDetailAction(true));
    setKey((prevKey) => prevKey + 1);
  };

  function createModel(response) {
    const table = new TableModel(response);
    table.columns.forEach((col, idx) => {
      if (col.field === "sys_creation_date") {
        col.type = "date";
        col.sortable = true;
      }
      if (col.headerName === "planning_event_id") {
        table.columns.splice(idx, 1);
      }
    });
    table.rows = table.rows.map((row) => {
      return {
        ...row,
        onClick: () => {
          handleModalOpen({
            is_event_actual: row.is_event_actual,
            planning_event_id: row.planning_event_id,
          });
        },
      };
    });
    return table;
  }

  return (
    <>
      <TableLoader {...loader} />
      {openElectronicConsents && <ModalElectronicConsepts key={key} />}
    </>
  );
}
